import React from "react";

type MarketingHeroProps = {
  title: string;
};

const MarketingHero = ({ title }: MarketingHeroProps) => {
  return (
    <section className="marketing-page__hero">
      <div className="marketing__container marketing-page__hero-inner">
        <h1>{title}</h1>
      </div>
    </section>
  );
};

export default MarketingHero;
